"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "giano-vetusto": {
    "784709a7": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "skipSearch": false
    }],
    "curti": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9ebd0158": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "skipSearch": false
    }],
    "fontana": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7c45b479": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "skipSearch": false
    }],
    "fontanelle": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e027cc4d": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "skipSearch": false
    }],
    "masserie": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6ed881f6": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "53da135e",
      "slug": "giano-vetusto",
      "name": "Giano Vetusto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;